import { FC } from 'react'
import style from './HorizontalLine.module.scss'

const HorizontalLine: FC = () => {
  return <hr className={style.hr} />
}

export default HorizontalLine
